import 'babel-polyfill'
import Vue from 'vue'
import SwHic, { App } from 'sw-hic'
// import SwHic, { App } from '../../fe-base/packages/index'
import 'sw-hic/sw-hic.css'
import router from '@/common/router'
import store from '@/common/store'

// if (process.env.NODE_ENV === 'development') {
//     require('./common/mock')
// }

Vue.config.productionTip = false
Vue.use(SwHic)

new Vue({
    render: h => h(App),
    router,
    store
}).$mount('#app')
